import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { EstadocuentamasivoComponent } from '../componentes/estadocuentamasivo/estadocuentamasivo.component';
import { EstadoCuentaComponent } from '../componentes/estado-cuenta/estado-cuenta.component';
import { GeneraRutasComponent } from '../componentes/genera-rutas/genera-rutas.component';
import { ConsultaLecturasComponent } from '../componentes/consulta-lecturas/consulta-lecturas.component';
import { VentanillaComponent } from '../componentes/ventanilla/ventanilla.component';
import { InformacionComponent } from '../componentes/informacion/informacion.component';
import { CorrecionLecturasComponent } from '../componentes/correcion-lecturas/correcion-lecturas.component';
import { CapturaLecturaRutasComponent } from '../componentes/captura-lectura-rutas/captura-lectura-rutas.component';
import { AuthGuard } from "app/_helpers/auth.guard";
import { MedidoresMedicionComponent } from '../componentes/medidores-medicion/medidores-medicion.component';
import { ReportesComponent } from './reportes/reportes.component';

const routes: Routes = [
  {
    path: "",
    children: [
      {
        path: "estadocuentamasivo",
        component: EstadocuentamasivoComponent,
        canActivate: [AuthGuard],
      },
    ],
  },
 

  {
    path: "",
    children: [
      {
        path: "genera-rutas",
        component: GeneraRutasComponent,
        canActivate: [AuthGuard],
      },
    ],
  },
  {
    path: "",
    children: [
      {
        path: "captura-lecturas",
        component: CapturaLecturaRutasComponent,
        canActivate: [AuthGuard],
      },
    ],
  },
  {
    path: "",
    children: [
      {
        path: "ventanilla",
        component: VentanillaComponent,
        canActivate: [AuthGuard],
      },
    ],
  },
  {
    path: "",
    children: [
      {
        path: "informacion",
        component: InformacionComponent,
        canActivate: [AuthGuard],
      },
    ],
  },
  // {
  //   path: "",
  //   children: [
  //     {
  //       path: "correcion-lecturas",
  //       component: CorrecionLecturasComponent,
  //       canActivate: [AuthGuard],
  //     },
  //   ],
  // },
  {
    path: "",
    children: [
      {
        path: "medidores",
        component: MedidoresMedicionComponent,
        canActivate: [AuthGuard],
      },
    ],
  },
  {
    path: "",
    children: [
      {
        path: "reporte-atencion",
        component: ReportesComponent,
        //canActivate: [AuthGuard],
      },
    ],
  },
];

@NgModule({
  declarations: [
   ],
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MedicionyfacturacionRoutingModule { }

